import { useEffect } from 'react';
import { ApiKeys } from './ApiKeys';
import { useApiKeysStore } from './apiKeysStore';

export function ApiKeysPage() {
  const { apiKeys: keys = [], loading: isLoading, fetchApiKeys } = useApiKeysStore();

  const { createApiKey, revokeApiKey } = useApiKeysStore();

  useEffect(() => {
    fetchApiKeys();
  }, [fetchApiKeys]);

  const handleCreateKey = async (data: { name: string; expiresAt: string | null }) => {
    // Remove expiresAt if it's null or empty to match backend schema (expects optional datetime string, not null)
    const payload: { name: string; expiresAt?: string } = { name: data.name };
    
    // Only add expiresAt if it has a valid value (not null, not empty string)
    if (data.expiresAt && data.expiresAt.trim() !== '') {
      // Convert date string (YYYY-MM-DD) to ISO datetime string
      const date = new Date(data.expiresAt);
      date.setHours(23, 59, 59, 999); // Set to end of day
      payload.expiresAt = date.toISOString();
    }
    
    return await createApiKey(payload);
  };

  const handleRevokeKey = async (id: string) => {
    await revokeApiKey(id);
  };

  return (
    <ApiKeys
      keys={keys}
      loading={isLoading}
      onCreateKey={handleCreateKey}
      onRevokeKey={handleRevokeKey}
    />
  );
}
